import { CleanSchema, get } from '../../../json-transform';
import { transformCaretKeysToDot } from './generalEventUtils';

export const getGeneralWs = new CleanSchema({
  'event.people_count__gte:integer': get('event.people_count__gte:integer').asInt().ifNaN(undefined),
  stream_ids: get('stream_ids').asArrayOfOptionValues().ifEmpty(undefined),
  'event.event.stream_id__in:string': get('event.event.stream_id__in:string').asArrayOfOptionValues().ifEmpty(undefined),
  'event.fight_score__gte:numeric': get('event.fight_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.weapon_score__gte:numeric': get('event.weapon_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.fire_score__gte:numeric': get('event.fire_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.facecover_score__gte:numeric': get('event.facecover_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.lying_score__gte:numeric': get('event.lying_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.handsup_score__gte:numeric': get('event.handsup_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  'event.fall_score__gte:numeric': get('event.fall_score__gte:numeric').asFloat().toNormalizedPercent().ifNaN(undefined),
  cities: get('cities').asArrayFromString(),
  areas: get('areas').asArrayFromString(),
  districts: get('districts').asArrayFromString(),
  streets: get('streets').asArrayFromString(),
  house_numbers: get('house_numbers').asArrayFromString(),
  origin_longitude: get('origin_longitude').asFloat().ifNaN(undefined),
  origin_latitude: get('origin_latitude').asFloat().ifNaN(undefined),
  longitude_delta: get('longitude_delta').asFloat().ifNaN(undefined),
  latitude_delta: get('latitude_delta').asFloat().ifNaN(undefined),
});

export const getGeneralWsEventsQS = (obj) => {
  const fixedObj = transformCaretKeysToDot(obj);
  return getGeneralWs(fixedObj);
};
